export const SET_CAUESES = 'SET_CAUESES'



// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/causes/mutation-types.ts